import CustomHeader from './CustomHeader.vue';

export default CustomHeader;
